import { minutesToHoursText } from './trainingReportForm';

const normalizeDate = (value) => String(value || '').slice(0, 10);

export const getAttendanceDates = (report = {}) => {
  const unique = new Set(
    (report.asistencias || [])
      .map((item) => normalizeDate(item.fecha))
      .filter(Boolean),
  );
  return [...unique].sort();
};

export const formatAttendanceDate = (value) => {
  const normalized = normalizeDate(value);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(normalized)) return normalized || 'Fecha';
  const [year, month, day] = normalized.split('-');
  return `${day}/${month}/${year}`;
};

export const createAttendanceDraft = (report = {}) => {
  const attendanceByParticipant = new Map();
  (report.asistencias || []).forEach((attendance) => {
    const id = Number(attendance.id_reporte_participante);
    if (!attendanceByParticipant.has(id)) attendanceByParticipant.set(id, {});
    attendanceByParticipant.get(id)[normalizeDate(attendance.fecha)] =
      attendance.asistio === null || attendance.asistio === undefined
        ? null
        : Boolean(attendance.asistio);
  });

  return (report.participantes || []).map((participant) => {
    const id = Number(participant.id_reporte_participante);
    return {
      id_reporte_participante: id,
      matricula_alumno: participant.matricula_alumno || '',
      nombre_completo: participant.nombre_completo || '',
      genero: participant.genero || '',
      horas_calculadas_minutos: Number(participant.horas_calculadas_minutos || 0),
      horas_conciliadas_horas:
        participant.horas_conciliadas_minutos === null ||
        participant.horas_conciliadas_minutos === undefined
          ? ''
          : minutesToHoursText(participant.horas_conciliadas_minutos),
      porcentaje_asistencia:
        participant.porcentaje_asistencia === null ||
        participant.porcentaje_asistencia === undefined
          ? null
          : Number(participant.porcentaje_asistencia),
      asistencias: attendanceByParticipant.get(id) || {},
    };
  });
};

export const buildParticipantPayload = (rows = []) =>
  rows.map((row) => ({
    id_reporte_participante: row.id_reporte_participante,
    genero: row.genero || null,
  }));

export const buildAttendancePayload = (rows = [], dates = []) =>
  rows.flatMap((row) =>
    dates.map((fecha) => ({
      id_reporte_participante: row.id_reporte_participante,
      fecha,
      asistio:
        row.asistencias?.[fecha] === null ||
        row.asistencias?.[fecha] === undefined
          ? null
          : Boolean(row.asistencias[fecha]),
    })),
  );

export const reconciledHoursToMinutes = (value) => {
  if (value === null || value === undefined || String(value).trim() === '') {
    return null;
  }
  const hours = Number(value);
  if (!Number.isFinite(hours) || hours < 0) return undefined;
  return Math.round(hours * 60);
};

export const getChangedReconciledHours = (rows = [], report = {}) => {
  const originals = new Map(
    (report.participantes || []).map((participant) => [
      Number(participant.id_reporte_participante),
      participant.horas_conciliadas_minutos === null ||
      participant.horas_conciliadas_minutos === undefined
        ? null
        : Number(participant.horas_conciliadas_minutos),
    ]),
  );

  return rows
    .map((row) => ({
      id_reporte_participante: row.id_reporte_participante,
      horas_conciliadas_minutos: reconciledHoursToMinutes(
        row.horas_conciliadas_horas,
      ),
    }))
    .filter(
      (item) =>
        item.horas_conciliadas_minutos !== undefined &&
        item.horas_conciliadas_minutos !==
          originals.get(Number(item.id_reporte_participante)),
    );
};

export const countPendingAttendance = (rows = [], dates = []) =>
  rows.reduce(
    (total, row) =>
      total +
      dates.filter(
        (date) =>
          row.asistencias?.[date] === null ||
          row.asistencias?.[date] === undefined,
      ).length,
    0,
  );
